import { ref } from 'vue'
import type { CurrentUserAndPermissions, Organization } from '@/generated/graphql'

export const currentOrganization = ref<Organization>()
export const currentUserAndPermissions = ref<CurrentUserAndPermissions | undefined>()
